<template>
  <b-container class="questionnaire-list">
    <b-btn class="float-right" variant="primary" @click="createQuestionnaire">
      Create New Questionnaire
    </b-btn>

    <h2>Questionnaires</h2>

    <DataTable
      ref="dataTable"
      :show-filters="true"
      :show-pager="true"
      :get-items="getQuestionnaires"
      :filters="filters"
      :filter-title="'Filter Questionnaires'"
      :fields="fields"
    >
      <!-- template for filters -->
      <template slot="filters">
        <b-row>
          <b-col cols="12" lg="4">
            <label>Title</label>
            <b-form-input v-model="filters.title.value" />
          </b-col>
          <b-col cols="12" lg="4" class="mt-2 mt-lg-0">
            <label>Society</label>
            <b-form-select
              v-model="filters.society_id.value"
              :options="societyOptions"
            />
          </b-col>
          <b-col cols="12" lg="4" class="mt-2 mt-lg-0">
            <label>Relation Type</label>
            <b-form-select
              v-model="filters.relation_type.value"
              :options="relationTypeOptions"
            />
          </b-col>
        </b-row>
      </template>

      <!-- templates for custom columns -->
      <template slot="society_id" slot-scope="data">
        {{
          data.item.society
            ? data.item.society.name
            : membershipTypesAsString(data.item.nonSocietyMembershipTypes)
        }}
      </template>

      <template slot="actions" slot-scope="data">
        <!-- we use @click.stop here to prevent emitting of a 'row-clicked' event  -->
        <b-dropdown
          split
          variant="info"
          size="sm"
          text="Edit"
          @click.stop="editQuestionnaire(data.item.id)"
        >
          <!--          <b-dropdown-item-button-->
          <!--            @click.stop="onCloneQuestionnaire(data.item.id)"-->
          <!--          >-->
          <!--            Clone-->
          <!--          </b-dropdown-item-button>-->
          <b-dropdown-item-button
            @click.stop="onDeleteQuestionnaire(data.item.id)"
          >
            Delete
          </b-dropdown-item-button>
        </b-dropdown>
      </template>
    </DataTable>
  </b-container>
</template>

<!-- ----------------------------------------------------------------------- -->

<script>
import DataTable from '@/components/DataTable';
import Api from '@/providers/Api.js';
import Help from '@/providers/Help';

export default {
  name: 'questionnaireList',
  components: {
    DataTable,
  },
  data() {
    return {
      filters: {
        id: { field: 'id', value: null },
        title: { field: 'title', type: 'string', value: null },
        society_id: { field: 'society.id', type: 'string', value: null },
        relation_type: { field: 'society.id', type: 'is_null', value: null },
      },
      fields: [
        // { key: 'id', sortable: true },
        { key: 'title', sortable: true },
        {
          key: 'society_id',
          sortable: false,
          custom: true,
          label: 'Society/Membership Types',
        },
        { key: 'actions', sortable: false, custom: true },
      ],
    };
  },
  computed: {
    societyOptions() {
      return this.$store.state.societyOptions;
    },
    relationTypeOptions() {
      return [
        { value: null, text: 'All' },
        { value: 0, text: 'Society Related' },
        { value: 1, text: 'Membership related' },
      ];
    },
  },
  methods: {
    editQuestionnaire(id) {
      this.$router.push(`/admin/questionnaire/edit/${id}`);
    },
    onCloneQuestionnaire(id) {
      Help.confirm.show('Create a copy of this questionnaire?', 'Yes', () => {
        this.cloneQuestionnaire(id);
      });
    },
    cloneQuestionnaire(id) {
      Api.cloneQuestionnaire(id).then(() => {
        this.$toasted.success('Questionnaire cloned', { duration: 3000 });
        this.$refs.dataTable.refresh();
      });
    },
    onDeleteQuestionnaire(id) {
      Help.confirm.show(
        'Permanently delete this questionnaire?',
        'Delete',
        () => {
          this.deleteQuestionnaire(id);
        }
      );
    },
    deleteQuestionnaire(id) {
      Api.deleteQuestionnaire(id).then(() => {
        this.$toasted.success('Questionnaire deleted', { duration: 3000 });
        this.$refs.dataTable.refresh();
      });
    },
    getQuestionnaires(listParams) {
      return Api.getQuestionnaires(this, this.filters, listParams);
    },
    createQuestionnaire() {
      this.$router.push(`/admin/questionnaire/create`);
    },
    membershipTypesAsString: function (membershipTypes) {
      return membershipTypes && Array.isArray(membershipTypes)
        ? membershipTypes.map(({ type_name }) => type_name).join(', ')
        : '';
    },
  },
};
</script>

<!-- ----------------------------------------------------------------------- -->

<style lang="scss"></style>
